/* eslint-disable no-console */
/* eslint-disable no-useless-catch */

import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import 'firebase/firebase-storage'
import * as constants from '../../constants.json'

/**
* Async function to upload media content.
* @param {object} media           - The media object to be stored in the storage.
* @param {string} companyId       - The company doc id.
* @param {string} loadUpload           - The boy doc id.
*/

export const storeMediaOnFirebase = (media, companyId, loadUpload) => {
  let fullName = ''
  let url = ''
  let type = media.type.slice(0, media.type.indexOf('/'))

  return new Promise(async (resolve, reject) => {
    const storeMedia = fullName => {
      console.log(`Storing ${fullName} to db`)

      return new Promise((resolve, reject) => {
        // Storing the data to the storage on Firebase.
        const fileData = firebase.storage().ref().child(`media/${companyId}/${fullName}`).put(media)

        console.log('Media stored')

        fileData.on(firebase.storage.TaskEvent.STATE_CHANGED, loadUpload, error => { throw error }, async () => {
          try {
            // Retrieving the file URL.
            url = await firebase.storage().ref().child(`media/${companyId}/${fullName}`).getDownloadURL()

            resolve(url)
          } catch (error) {
            console.log(error)
            reject(error)
          }
        }
        )
      })
    }

    // Reaching out to firebase and store the media file.
    try {
      // Split the media name.
      let fileName = media.name.slice(0, media.name.indexOf('.'))
      let fileExtension = media.name.slice(media.name.indexOf('.') + 1)

      console.log('Media name splitted')

      // Get the media collection ordered by name.
      const dataRef = firebase
        .firestore()
        .collection('companies')
        .doc(companyId)
        .collection('bots')
        .doc(constants.BOT_ID)
        .collection('media')
      const queryMedia = await dataRef.orderBy('name').get()

      console.log('Got media collection from db')

      // Create the media name, if we have a repeated name we add a sufix (1).
      if (!queryMedia.empty) {
        let sufix = 1
        queryMedia.docs.forEach(doc => {
          if (doc.data().name === media.name) {
            fileName = `${fileName}(${sufix})`
            fullName = `${fileName}.${fileExtension}`
            sufix++
          } else {
            fullName = `${fileName}.${fileExtension}`
          }
        })
      } else {
        fullName = `${fileName}.${fileExtension}`
      }
      // Store the media on firebase storage and the url to the database.
      const fileUrl = await storeMedia(fullName)

      console.log('fullname created:', fullName)
      resolve({ fileUrl, fullName, type })
    } catch (error) {
      console.log(error)
      reject(error)
    }
  })
}

/**
 * Transform the categoriesMap into an array and add an index
 * @param {*} categoryMap
 * @param {*} categoryMapIndex
 * @param {*} index
 */
export const generateCategorySelector = (categoryMap, categoryMapIndex, index = '0') => {
  categoryMap.forEach((item, i) => {
    let newIndex
    if (index === '0') {
      newIndex = `${i + 1}`
    } else {
      newIndex = `${index}.${i + 1}`
    }

    for (let key in item) {
      if (typeof (item[key]) === 'string') {
        categoryMapIndex.push({
          name: `${newIndex} ${item[key]}`,
          id: key
        })
      } else {
        generateCategorySelector(item[key], categoryMapIndex, `${newIndex}`)
      }
    }
  })
}

/**
 * Verify if and object is empty.
 * @param {*} obj  - The object to be evaluated.
 * @returns a boolean: true if empty, false if not.
 */
export const objIsEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) { return false }
  }
  return true
}

/**
 * Go through the whole tree of categories and add each parent category ancestor's name to keywords and categories arrays.
 * @param {object} relationshipsMap  - The category relationship map.
 * @param {object} categoryNames     - The category names.
 * @param {string} parentId          - The origin parent category id.
 * @param {object} keywords          - The keywords array.
 * @param {object} categories        - The category array.
 */
export const addCategoryToKeyword = (relationshipsMap, categoryNames, parentId, keywords, categories) => {
  // Verify if the parent has a parent.
  if (relationshipsMap[parentId] !== null && relationshipsMap[parentId] !== 'none') {
    // Add grandparent to keywords and category arrays.
    let itExists = false
    keywords.forEach(el => {
      // If grandparent name already exits on keywords array we set the flag.
      if (categoryNames[relationshipsMap[parentId]].toLowerCase() === el) {
        itExists = true
      }
    })

    if (!itExists) {
      keywords.push(categoryNames[relationshipsMap[parentId]].toLowerCase())
    }
    categories.push(relationshipsMap[parentId])

    // Go through the categories three and repeat the proces until we reach the last ancestor.
    addCategoryToKeyword(relationshipsMap, categoryNames, relationshipsMap[parentId], keywords, categories)
  } else {

  }
}

/**
 * Go through the whole tree of categories and delete each parent category ancestor's name in keywords and categories arrays.
 * @param {object} relationshipsMap  - The category relationship map.
 * @param {object} categoryNames     - The category names.
 * @param {string} parentId          - The origin parent category id.
 * @param {object} keywords          - The keywords array.
 * @param {object} categories        - The category array.
 */
export const deleteCategoriesAndKeywords = (relationshipsMap, categoryNames, parentId, keywords, categories) => {
  // Verify if the parent has a parent.
  if (relationshipsMap[parentId] !== null && relationshipsMap[parentId] !== 'none') {
    // Delete the category name from keywords and category arrays.
    if (keywords.indexOf(categoryNames[relationshipsMap[parentId]].toLowerCase()) !== -1) {
      keywords.splice(keywords.indexOf(categoryNames[relationshipsMap[parentId]].toLowerCase()), 1)
    }
    categories.splice(categories.indexOf(relationshipsMap[parentId]), 1)

    // Go through the categories three and repeat the proces until we reach the last ancestor.
    deleteCategoriesAndKeywords(relationshipsMap, categoryNames, relationshipsMap[parentId], keywords, categories)
  } else {

  }
}

/**
 * Push the category name in its corresponding position within its category tree and set a flag that let us
 * know that it has been added.
 * @param {object} categoriesMap     - The category relationship map
 * @param {string} categoryId        - The category's id to be added to the tree.
 * @param {string} categoryName      - The category's name.
 * @param {string} parentId          - The category's parent id.
 * @param {boolean} categoryAdded    - The flag: true = category added, false = category not added.
 */
export const pushToCategoryMap = (categoriesMap, categoryId, categoryName, parentId, categoryAdded) => {
  for (let el of categoriesMap) {
    for (let key in el) {
      if (key !== 'childs') {
        if (key === parentId) {
          el.childs.push({
            [categoryId]: categoryName,
            childs: []
          })
          categoryAdded.value = true
          return
        } else {
          pushToCategoryMap(el.childs, categoryId, categoryName, parentId, categoryAdded)
        }
      }
    }
  }
}

/**
 * Generate the category map
 * @param {string} relationshipsMap  - The relationships map.
 * @param {string} categoriesNames   - The categories name object.
 * @param {string} thisCategoryId    - The category id of the actual document.
 */
export const generateCategoryMap = (relationshipsMap, categoriesNames, thisCategoryId) => {
  // Add all the first ancestor of parent categories to the category map.

  // console.log('relationshipsMap', relationshipsMap)
  let categoryMap = []

  for (let key in relationshipsMap) {
    // console.log('thisCategoryId: ', thisCategoryId)

    // console.log(`key-${key}:${relationshipsMap[key]}`)
    if ((relationshipsMap[key] === 'none' || relationshipsMap[key] === null) && key !== thisCategoryId) {
      categoryMap.push({
        [key]: categoriesNames[key],
        childs: []
      })
    }
  }

  // console.log('categoryMap', categoryMap)

  // Go through all the relationship map and add each category to its correspondent place in the
  // category map.

  console.log('id', thisCategoryId)
  let checkList = {}

  for (let key in relationshipsMap) {
    console.log(`key-${key}:${relationshipsMap[key]}`)
    let thisIdIsParentOfThiskey = false
    if (key === thisCategoryId) {
      thisIdIsParentOfThiskey = true
    } else {
      // Verify if the actual category id belongs to any category tree, if true we dont add any member of that
      // family tree.
      let checkCategoryId = key
      while (
        relationshipsMap[checkCategoryId] !== 'none' &&
        relationshipsMap[checkCategoryId] !== null
      ) {
        if (relationshipsMap[checkCategoryId] === thisCategoryId) {
          thisIdIsParentOfThiskey = true
        }
        checkCategoryId = relationshipsMap[checkCategoryId]
      }
    }
    // If the category Id is not parent of the key being evaluated we add it to the category map
    if (
      relationshipsMap[key] !== 'none' &&
      relationshipsMap[key] !== null &&
      !thisIdIsParentOfThiskey
    ) {
      // console.log('relationshipsMap[key]', relationshipsMap[key])
      let categoryAdded = { value: false }
      pushToCategoryMap(
        categoryMap,
        key,
        categoriesNames[key],
        relationshipsMap[key],
        categoryAdded
      )

      // console.log('categoryAdded', categoryAdded.value)
      // If a category has been added to the category map, we mark it as true
      // all the remaining categories id will be added later.
      categoryAdded.value
        ? (checkList[key] = true)
        : (checkList[key] = false)
    }

    // console.log('categoryMap', categoryMap)

    // console.log('checkList', checkList)
  }

  // Adding all the remaining categories Id to the category map.
  let checkListDone = false
  while (!checkListDone) {
    checkListDone = true

    for (let key in checkList) {
      // If the key is not in the category map
      if (checkList[key] === false) {
        // console.log(`key-${key}:${relationshipsMap[key]}`)
        let checkCategoryId = key
        let thisKeyIsRelateToThisId = false
        // Verify if the actual category id belongs to any category tree, if true we dont add any member of that
        // family tree.
        if (key === thisCategoryId) {
          thisKeyIsRelateToThisId = true
        } else {
          while (relationshipsMap[checkCategoryId] !== 'none' && relationshipsMap[checkCategoryId] !== null) {
            if (relationshipsMap[checkCategoryId] === thisCategoryId) {
              thisKeyIsRelateToThisId = true
            }
            checkCategoryId = relationshipsMap[checkCategoryId]
          }
        }
        // If the category Id is not parent of the key being evaluated we add it to the category map
        if (relationshipsMap[key] !== 'none' && relationshipsMap[key] !== null && !thisKeyIsRelateToThisId) {
          let categoryAdded = { value: false }
          pushToCategoryMap(categoryMap, key, categoriesNames[key], relationshipsMap[key], categoryAdded)

          // console.log('categoryAdded', categoryAdded.value)
          if (categoryAdded.value) {
            checkList[key] = true
          } else {
            checkList[key] = false
            checkListDone = false
          }
        }
      }
    }
  }

  console.log('categoryMap', categoryMap)

  console.log('checkList', checkList)
  return [...categoryMap]
}

/**
 * Go through the whole tree of categories and return each parent category ancestor's ids.
 *
 * @param {object} relationshipsMap  - The category relationship map.
 * @param {string} parentId          - The origin parent category id.
 *
 * @returns An array containing the categort tree.
 */
export const getCategoryTree = (relationshipsMap, parentId) => {
  const categories = []
  const getTree = (relationshipsMap, parentId, categories) => {
    // Verify if the parent has a parent.
    if (relationshipsMap[parentId] !== null && relationshipsMap[parentId] !== 'none') {
      // Add category idd to the array
      categories.push(relationshipsMap[parentId])

      // Go through the categories three and repeat the proces until we reach the last ancestor.
      getCategoryTree(relationshipsMap, relationshipsMap[parentId], categories)
    } else {

    }
  }
  getTree(relationshipsMap, parentId, categories)

  return categories
}
/**
 * Activate the order processed flow in manychat
 * @param {string} subscriberId
 * @param {string} manychatToken
 */
/* eslint-disable */
export const  orderProcessedFLow = async (subscriberId, manychatToken) => {
  const corsProxy = 'https://cors-anywhere.herokuapp.com/'
  const sendFlowUrl = 'https://api.manychat.com/fb/sending/sendFlow'
  try{
    console.log('manychat orderProcessedFLow: ', manychatToken)
    console.log('subscriberId: ', subscriberId)
    
    const token = `Bearer ${manychatToken}`
    // Setting custom field
    const  headers = {
      'accept': 'application/json',
      'Authorization': token,
      'Content-Type': 'application/json'
    }
    
    const data = {
      "subscriber_id": subscriberId,
      "flow_ns": "content20200229172640_108912"
    }
    
    await fetch(corsProxy+sendFlowUrl, {
      body: JSON.stringify(data),
      headers,
      method: 'POST'
    })
    
  }catch (error) {
    throw error
  }
}



export const  sendBotMessage = async (companyId, subscriberId, orderNumber, command) => {
  // const corsProxy = 'https://cors-anywhere.herokuapp.com/'
  // const setCustomFieldUrl = 'https://api.manychat.com/fb/subscriber/setCustomFieldByName'
  // const sendFlowUrl = 'https://api.manychat.com/fb/sending/sendFlow'
  try{
    const webhook = 'https://b02eff2f0761.ngrok.io/web/messages'
    
    console.log('orderProcessedFLow')
    console.log('subscriberId: ', subscriberId)
    console.log('orderNumber: ', orderNumber)
    
    const data = {
      pageId: companyId,
      facebookUserId: subscriberId,
      command,
      payload: orderNumber
    }

    // await request({
    //   method: 'POST',
    //   json: true,
    //   body:  {
    //     pageId: companyId,
    //     facebookUserId: subscriberId,
    //     command,
    //     payload: orderNumber
    //   },
    //   uri: webhook
    // });
        await fetch(webhook, {
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
          mode: 'no-cors'
        })

  }catch (error) {
    throw error
  }
}

// /**
//  * Activate the order dispatched flow in manychat and send the order number.
//  * @param {string} subscriberId   - The subscriber id
//  * @param {string} manychatToken  - The manychat token
//  * @param {string} orderNumber    - The order's number
//  * @param {string} flow           - The flow: processed or dispatched
//  */
// export const  manychatFlow = async (subscriberId, manychatToken, orderNumber, flow) => {
//   const corsProxy = 'https://cors-anywhere.herokuapp.com/'
//   const setCustomFieldUrl = 'https://api.manychat.com/fb/subscriber/setCustomFieldByName'
//   const sendFlowUrl = 'https://api.manychat.com/fb/sending/sendFlow'
//   try{
//     console.log('manychat orderProcessedFLow: ', manychatToken)
//     console.log('subscriberId: ', subscriberId)
//     console.log('orderNumber: ', orderNumber)
    
//     const token = `Bearer ${manychatToken}`
//     const  headers = {
//       'accept': 'application/json',
//       'Authorization': token,
//       'Content-Type': 'application/json'
//     }
    
//     // Setting custom field
//     let data1 = {
//       "subscriber_id": subscriberId,
//       "field_name": "orderNumber",
//       "field_value": orderNumber
//     }
    
//     // Setting flow
//     let data2 = {}
//     switch (flow){
//       case 'processed-delivering': 
//         data2 = {
//           "subscriber_id": subscriberId,
//           "flow_ns": "content20200309165010_091257"
//         }
//         break
//       case 'dispatched-delivering':
//         data2 = {
//           "subscriber_id": subscriberId,
//           "flow_ns": "content20200309165455_747549"
//         }
//         break
//       case 'processed-pickup':
//         data2 = {
//           "subscriber_id": subscriberId,
//           "flow_ns": "content20200312193754_704458"
//         }
//         break
//       case 'dispatched-pickup':
//         data2 = {
//           "subscriber_id": subscriberId,
//           "flow_ns": "content20200312173832_654318"
//         }
//         break
//     }
    
//     await fetch(corsProxy+setCustomFieldUrl, {
//       body: JSON.stringify(data1),
//       headers,
//       method: 'POST'
//     })
    
//     await fetch(corsProxy+sendFlowUrl, {
//       body: JSON.stringify(data2),
//       headers,
//       method: 'POST'
//     })    
//   }catch (error) {
//     throw error
//   }
// }